import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TechnologyLaptop = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19 22H13C12.448 22 12 22.448 12 23C12 23.552 12.448 24 13 24H19C19.552 24 20 23.552 20 23C20 22.448 19.552 22 19 22Z" />
		<path d="M27.732 23.156C27.707 23.087 27.616 22.84 27.486 22.489C26.145 18.858 25.88 18.142 25.82 17.982C25.638 17.478 25.328 17.045 24.935 16.712C25.595 15.999 25.999 15.045 25.999 13.999V6.99902C25.999 5.34502 24.653 3.99902 22.999 3.99902H8.99905C7.34505 3.99902 5.99905 5.34502 5.99905 6.99902V13.999C5.99905 15.045 6.40305 15.999 7.06305 16.712C6.67005 17.044 6.36005 17.477 6.17805 17.982C6.11805 18.142 5.85305 18.858 4.51205 22.489C4.38205 22.842 4.29105 23.089 4.26605 23.155C4.08805 23.582 3.99805 24.034 3.99805 24.499C3.99805 26.429 5.56805 27.999 7.49805 27.999H24.498C26.428 27.999 27.998 26.429 27.998 24.499C27.998 24.034 27.908 23.582 27.73 23.155L27.732 23.156ZM8.00005 7.00002C8.00005 6.44902 8.44905 6.00002 9.00005 6.00002H23C23.551 6.00002 24 6.44902 24 7.00002V14C24 15.103 23.103 16 22 16H10C8.89705 16 8.00005 15.103 8.00005 14V7.00002ZM24.5 26H7.50005C6.67305 26 6.00005 25.327 6.00005 24.5C6.00005 24.297 6.04005 24.1 6.11905 23.915C6.12505 23.902 8.05905 18.67 8.06105 18.662C8.20405 18.266 8.58105 18 9.00005 18H23C23.419 18 23.796 18.266 23.939 18.662C23.942 18.67 25.876 23.901 25.881 23.915C25.96 24.1 26 24.297 26 24.5C26 25.327 25.327 26 24.5 26Z" />
	</svg>
);

export default TechnologyLaptop;
